// extracted by mini-css-extract-plugin
export default {"carousel-item":"documents-carousel_carousel-item__AcmpU","carousel-inner":"documents-carousel_carousel-inner__DpM49"};